// Replica TypeScript do U_regexProcesso (PortalNF/custom.asc.portalnf.regexProcesso.tlpp).
// Identifica referencias de processo de importacao em texto livre (descricao
// do servico, nome do arquivo, etc) e devolve no formato "SIGLA NNNN/AA".
// Valida que o total de digitos (numero + ano) seja exatamente 6.

const SIGLAS = [
  'ACEPR', 'ACESC', 'ACEES', 'ACERO', 'ACESCO', 'ACESP',
  'ACPE', 'ACSP', 'ACPR', 'ACES', 'ACRO', 'ACRJ', 'ACMG',
  'AC', 'PR'
];

// Ordena por tamanho desc para o regex casar a maior sigla primeiro
// (ex.: "ACPR" antes de "AC" e "PR").
// Exportada para quem precisa localizar a sigla com regra propria de fronteira
// (cte-parser) antes de delegar a normalizacao para extractProcesso.
export const SIGLA_ALT = SIGLAS.sort((a, b) => b.length - a.length).join('|');

// Padrao: sigla + (espaco opcional) + 1-6 digitos + (separador opcional + 2 digitos)
const PROCESSO_REGEX = new RegExp(
  `(?i)(${SIGLA_ALT})\\s?\\d{1,6}((/|\\s)\\d{2})?`.replace('(?i)', ''),
  'i'
);

export function extractProcesso(text: string): string {
  if (!text) return '';

  const match = text.match(PROCESSO_REGEX);
  if (!match) return '';

  const base = match[0].toUpperCase().trim();

  let alpha = '';
  let dig = '';
  let foundDig = false;

  for (const ch of base) {
    if (ch === ' ' || ch === '/') continue;
    if (/\d/.test(ch)) {
      dig += ch;
      foundDig = true;
    } else {
      if (foundDig) continue;
      alpha += ch;
    }
  }

  if (dig.length !== 6 || !alpha) return '';

  return `${alpha} ${dig.substring(0, 4)}/${dig.substring(4, 6)}`;
}
